import { render, staticRenderFns } from "./chooseDetail.vue?vue&type=template&id=42b56225"
import script from "./chooseDetail.vue?vue&type=script&lang=js"
export * from "./chooseDetail.vue?vue&type=script&lang=js"
import style0 from "./chooseDetail.vue?vue&type=style&index=0&id=42b56225&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports